import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { forwardRef } from 'react';
/**
 * Text Areas are a type of **atom** that represent a `<textarea>` element.
 */
const TextArea = forwardRef(({ className, ...rest }, textAreaRef) => {
    return (_jsx("textarea", { className: buildClassName('border-darker-gray box-border rounded-lg border border-solid', 'focus:border-primary-blue focus:-m-px focus:border-2 focus:outline-none', 'read-only:border-black/20 read-only:bg-white read-only:text-black/20', 'skyline-text-body-1 leading-5.5 placeholder-medium-gray text-black', 'block w-full px-4 py-3', 'resize-none disabled:bg-[#E8EBF0]', className), ...rest, ref: textAreaRef }));
});
export default TextArea;
//# sourceMappingURL=TextArea.js.map